import { useTranslation } from 'react-i18next';

interface LanguageToggleProps {
  scrolled?: boolean;
}

export default function LanguageToggle({ scrolled = true }: LanguageToggleProps) {
  const { i18n } = useTranslation();
  const isSpanish = (i18n.language || 'en').startsWith('es');
  const label = isSpanish ? 'English' : 'Spanish';

  const toggle = () => {
    const next = isSpanish ? 'en' : 'es';
    i18n.changeLanguage(next);
    localStorage.setItem('i18nextLng', next);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      className={`flex items-center gap-2 text-sm font-semibold px-4 py-2.5 rounded-full border transition-colors duration-200 cursor-pointer whitespace-nowrap ${
        scrolled
          ? 'border-gray-300 text-gray-600 hover:text-teal-500 hover:border-teal-300'
          : 'border-white/40 text-white hover:bg-white/10'
      }`}
    >
      <i className="ri-translate-2 text-base" />
      {label}
    </button>
  );
}